var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 107,
    viewBox: "0 0 108 107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074",
    transform: "translate(-6 -3325)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\u2605",
    transform: "translate(60 3419)",
    fill: "red",
    fontSize: 107,
    fontFamily: "HiraginoSans-W3, Hiragino Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -53.5,
    y: 0
  }, "\u2605")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedStar);
export default __webpack_public_path__ + "static/media/red-star.00f629ce7f2a5ac500fe53ee3e531f51.svg";
export { ForwardRef as ReactComponent };